const c = (e, l, f, s, a) => {
  if (a) {
    s === "header" ? (e(!0), l(!1)) : s === "footer" && (e(!1), l(!0));
    return;
  }
  f();
}, n = (e, l, f) => {
  e(!1), l(!1), f();
}, i = (e, l, f, s) => {
  s || (e(!1), l(!1)), f(s);
};
export {
  n as confirmClose,
  c as handleCloseClick,
  i as handleDialogOpenChange
};
